import React, { useState } from 'react';
import useFormStatus from '../../Hooks/useFormStatus';
import { FREE_PROPERTY_DETAILS_ENDPOINT } from '../../urls';
import { fetchApiData } from '../../Utils/ApiCalls';
import { inputGroups } from '../../Constants/Constants';
import { Alert } from '../Alert';
import LoaderCircle from '../LoaderCircle';
import { Button, Input, Typography } from '@attentive-platform/stem-ui';

export const FreePropertyUpdateForm = () => {
  const initialData = {
    id: '',
    name: '',
    free_properties: '',
    free_properties_manual: '',
    free_properties_blueprint: '',
    free_properties_blueprint_manual: ''
  };

  const [freePropertyFetchedData, setFreePropertyFetchedData] = useState(initialData);
  const [loading, setLoading] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [formData, setFormData] = useState(initialData);
  const [email, setEmail] = useState('');
  const { successMessage, errorMessage, handleApiResult } = useFormStatus();

  const handleFormDataChange = (e, field) => {
    setFormData({
      ...formData,
      [field]: !isNaN(Number(e.target.value)) ? Number(e.target.value) : ''
    });
  };

  const handleSubmitRequest = async e => {
    e.preventDefault();
    setUpdating(true);
    formData.company = formData.id;
    const response = await fetchApiData({
      endpoint: FREE_PROPERTY_DETAILS_ENDPOINT,
      data: formData
    });
    handleApiResult(response);

    if (response.error === null) {
      setFormData(response.data);
      setFreePropertyFetchedData(response.data);
    }
    setUpdating(false);
  };

  const handleSearchClick = async e => {
    setLoading(true);

    e.preventDefault();

    const response = await fetchApiData({
      endpoint: `${FREE_PROPERTY_DETAILS_ENDPOINT}?email=${encodeURIComponent(email.toLowerCase())}`,
      data: null,
      apiRequest: 'GET'
    });
    handleApiResult(response);
    setLoading(false);

    if (response.data) {
      setFormData(response.data);
      setFreePropertyFetchedData(response.data);
    }
  };
  const propertyRows = inputGroups.filter(group => group.field);

  return (
    <div>
      <Alert errorMessage={errorMessage} successMessage={successMessage} />

      <div className='mb-3 flex'>
        <Input
          type='email'
          placeholder="Search company admin's email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          fullWidth
        />
        <Button
          color='primary'
          variant='contained'
          onClick={handleSearchClick}
          disabled={loading}
          size='medium'
          className='text-base min-w-0 w-8 px-4 rounded-r-2xl'>
          {loading ? <LoaderCircle /> : <i className='ri-search-line'></i>}
        </Button>
      </div>

      {/* table headers*/}
      <div className='grid grid-cols-[1fr_1fr_1fr] gap-4 mb-2 p-2 bg-gray-100 rounded-md'>
        <Typography variant='body3' className='font-semibold'>
          Property type
        </Typography>
        <Typography variant='body3' className='font-semibold'>
          FP left
        </Typography>
        <Typography variant='body3' className='font-semibold'>
          Update
        </Typography>
      </div>

      {/* property rows*/}
      <div className='space-y-2 mb-4'>
        {propertyRows.map((group, index) => (
          <div key={index} className='grid grid-cols-[1fr_1fr_1fr] gap-4 items-center'>
            <Typography variant='body3' className='pl-2'>
              {group.label}
            </Typography>
            <Input type='number' value={freePropertyFetchedData[group.field] || ''} disabled className='text-center' />
            <Input
              type='number'
              value={formData[group.field] ?? ''}
              onChange={e => handleFormDataChange(e, group.field)}
              placeholder='0'
              className='text-center'
            />
          </div>
        ))}
      </div>
      <div className='flex justify-end'>
        <Button color='primary' size='medium' variant='contained' onClick={handleSubmitRequest} disabled={updating}>
          {updating ? <LoaderCircle /> : 'Update'}
        </Button>
      </div>
    </div>
  );
};
